// The way back up.
//
// Jacky's standing rule (2026-09-12): any screen that scrolls past a viewport
// owes him a way back to the top, placed near where he is already clicking —
// not a far-corner control that costs a reach and a hunt. "Scrolling down is
// normal; making him scroll back up to act is the failure."
//
// It appears only once the page has actually scrolled, so it never covers
// content on a short screen.
import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

const SHOW_AFTER_PX = 600;

export function backToTopVisible(scrollY: number): boolean {
  return scrollY > SHOW_AFTER_PX;
}

export function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(backToTopVisible(window.scrollY));
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      className="fixed bottom-20 right-4 z-30 flex items-center gap-1.5 rounded-full border bg-card/95 px-3 py-2 text-micro font-medium shadow-lg backdrop-blur hover:bg-muted md:bottom-6"
    >
      <ArrowUp className="h-4 w-4" aria-hidden="true" />
      Top
    </button>
  );
}
